(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecomhub-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cleanups = new WeakMap();
    var lightbox;
    var lightboxImg;
    var photoTrigger;
    document.addEventListener('click', function (event) {
      var play = event.target.closest && event.target.closest('[data-ecomhub-video-play]');
      if (play) {
        var card = play.closest('[data-ecomhub-video-card]');
        var template = card && card.querySelector('template[data-ecomhub-video-embed]');
        if (template && !card.querySelector('iframe')) {
          card.appendChild(template.content.cloneNode(true));
          card.querySelector('iframe').focus();
        }
        return;
      }
      var photo = event.target.closest && event.target.closest('[data-ecomhub-review-photo]');
      if (!photo) return;
      if (!lightbox) {
        lightbox = document.createElement('dialog');
        lightbox.className = 'ecomhub-reviews__lightbox';
        lightbox.setAttribute('aria-label', 'Foto de la reseña');
        lightboxImg = document.createElement('img');
        lightboxImg.alt = 'Foto de la reseña ampliada';
        lightbox.appendChild(lightboxImg);
        document.body.appendChild(lightbox);
        lightbox.addEventListener('click', function () { lightbox.close(); });
        lightbox.addEventListener('close', function () {
          lightbox.classList.remove('is-open');
          lightboxImg.removeAttribute('src');
          if (photoTrigger && photoTrigger.isConnected) photoTrigger.focus();
        });
      }
      photoTrigger = photo;
      lightboxImg.src = photo.getAttribute('data-ecomhub-review-photo');
      lightbox.showModal();
      lightbox.classList.add('is-open');
    });

    function initialize(root) {
    var reveals = root.querySelectorAll('.ecomhub-reviews__reveal');
    if ('IntersectionObserver' in window && reveals.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            entry.target.classList.remove('is-pending');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      reveals.forEach(function (el) {
        el.classList.add('is-pending');
        observer.observe(el);
        cleanups.set(el, function () { observer.unobserve(el); });
      });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    var videoWizards = root.querySelectorAll('[data-ecomhub-video-wizard]');
    videoWizards.forEach(function (wizard) {
      if (wizard.getAttribute('data-ecomhub-initialized') === 'true') return;
      wizard.setAttribute('data-ecomhub-initialized', 'true');
      var section = wizard.closest('.ecomhub-video-wizard');
      var track = wizard.querySelector('.ecomhub-video-wizard__track');
      var originalCards = Array.prototype.slice.call(wizard.querySelectorAll('[data-ecomhub-video-card]'));
      if (!section || !track || originalCards.length < 2) return;

      var lastClone = originalCards[originalCards.length - 1].cloneNode(true);
      var firstClone = originalCards[0].cloneNode(true);
      lastClone.setAttribute('aria-hidden', 'true');
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('data-ecomhub-video-clone', 'true');
      firstClone.setAttribute('data-ecomhub-video-clone', 'true');
      [lastClone, firstClone].forEach(function (clone) {
        clone.setAttribute('inert', '');
        clone.querySelectorAll('video, source, iframe').forEach(function (media) {
          media.removeAttribute('src');
          media.removeAttribute('srcdoc');
          media.removeAttribute('autoplay');
          media.setAttribute('preload', 'none');
        });
      });
      track.insertBefore(lastClone, originalCards[0]);
      track.appendChild(firstClone);

      var cards = Array.prototype.slice.call(wizard.querySelectorAll('[data-ecomhub-video-card]'));
      var position = 1;
      var settleTimer = null;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = section.getAttribute('data-ecomhub-autoplay') !== 'false' && !reducedMotion;
      var parsedInterval = Number(section.getAttribute('data-ecomhub-interval')) || 3000;
      var interval = Math.min(10000, Math.max(2000, parsedInterval));
      var autoplayTimer = null;
      var paused = false;
      var inView = false;
      var boundaryTimer = null;
      var frame = null;

      var alignCard = function (card, smooth) {
        if (!card) return;
        var left = card.offsetLeft - (wizard.clientWidth - card.offsetWidth) / 2;
        wizard.scrollTo({ left: Math.max(0, left), behavior: smooth && !reducedMotion ? 'smooth' : 'auto' });
      };
      var setActive = function (card) {
        var realIndex = card && card.getAttribute('data-ecomhub-video-card');
        cards.forEach(function (candidate) {
          var isActive = candidate === card;
          candidate.classList.toggle('ecomhub-video-wizard__card--active', isActive);
          var shouldPlay = isActive && inView && !document.hidden && !reducedMotion && !candidate.hasAttribute('data-ecomhub-video-clone');
          var iframe = candidate.querySelector('iframe');
          if (iframe && (!isActive || !inView || document.hidden)) iframe.remove();
          var video = candidate.querySelector('video');
          if (!video) return;
          if (shouldPlay) {
            var playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
          } else {
            video.pause();
          }
        });
        if (realIndex) wizard.setAttribute('aria-label', 'Videos del producto. Video ' + realIndex + ' activo.');
      };
      var resetBoundary = function () {
        if (position === 0) {
          position = originalCards.length;
          alignCard(cards[position], false);
          setActive(cards[position]);
        } else if (position === cards.length - 1) {
          position = 1;
          alignCard(cards[position], false);
          setActive(cards[position]);
        }
      };
      var move = function (direction) {
        position += direction;
        position = Math.min(cards.length - 1, Math.max(0, position));
        alignCard(cards[position], true);
        setActive(cards[position]);
        if (boundaryTimer) window.clearTimeout(boundaryTimer);
        boundaryTimer = window.setTimeout(resetBoundary, reducedMotion ? 0 : 360);
      };
      var stopAutoplay = function () {
        if (autoplayTimer) window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      };
      var startAutoplay = function () {
        stopAutoplay();
        if (!autoplay || paused || !inView || document.hidden) return;
        autoplayTimer = window.setInterval(function () { move(1); }, interval);
      };

      var previous = section.querySelector('[data-ecomhub-video-prev]');
      var next = section.querySelector('[data-ecomhub-video-next]');
      if (previous) previous.addEventListener('click', function () { move(-1); startAutoplay(); });
      if (next) next.addEventListener('click', function () { move(1); startAutoplay(); });
      cards.forEach(function (card, cardPosition) {
        card.addEventListener('click', function (event) {
          if (event.target && event.target.closest && event.target.closest('button, a, video, iframe')) return;
          if (cardPosition === position) return;
          move(cardPosition > position ? 1 : -1);
          startAutoplay();
        });
      });
      wizard.addEventListener('scroll', function () {
        if (settleTimer) window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(function () {
          var viewportRect = wizard.getBoundingClientRect();
          var center = viewportRect.left + viewportRect.width / 2;
          var nearest = cards.reduce(function (best, card, index) {
            var rect = card.getBoundingClientRect();
            var distance = Math.abs(rect.left + rect.width / 2 - center);
            return !best || distance < best.distance ? { card: card, distance: distance, index: index } : best;
          }, null);
          if (!nearest) return;
          position = nearest.index;
          setActive(nearest.card);
          resetBoundary();
          startAutoplay();
        }, 120);
      }, { passive: true });
      section.addEventListener('mouseenter', function () { paused = true; stopAutoplay(); });
      section.addEventListener('mouseleave', function () { paused = false; startAutoplay(); });
      section.addEventListener('focusin', function () { paused = true; stopAutoplay(); });
      section.addEventListener('focusout', function () { paused = false; startAutoplay(); });
      var syncVisibility = function () { setActive(cards[position]); startAutoplay(); };
      var resize = function () { alignCard(cards[position], false); };
      var visibilityObserver;
      if ('IntersectionObserver' in window) {
        visibilityObserver = new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          syncVisibility();
        }, { threshold: 0.1 });
        visibilityObserver.observe(section);
      } else {
        inView = true;
      }
      document.addEventListener('visibilitychange', syncVisibility);
      window.addEventListener('resize', resize);
      cleanups.set(wizard, function () {
        inView = false;
        stopAutoplay();
        window.clearTimeout(settleTimer);
        window.clearTimeout(boundaryTimer);
        window.cancelAnimationFrame(frame);
        if (visibilityObserver) visibilityObserver.disconnect();
        document.removeEventListener('visibilitychange', syncVisibility);
        window.removeEventListener('resize', resize);
        setActive(null);
      });
      frame = window.requestAnimationFrame(function () {
        alignCard(cards[position], false);
        setActive(cards[position]);
        startAutoplay();
      });
    });
    }
    initialize(document);
    document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-ecomhub-video-wizard], .ecomhub-reviews__reveal').forEach(function (wizard) {
        var cleanup = cleanups.get(wizard);
        if (cleanup) cleanup();
        cleanups.delete(wizard);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
